import React, { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SettingsMenu from "./SettingsMenu";
import { useLocation } from "react-router-dom";
import useIsMobile from "../hooks/mobile";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const isSettingsPage = location.pathname.startsWith("/settings");
  const [sidebarVisible, setShowSidebar] = useState(true);
  const isMobile = useIsMobile(); // use the hook from before

  return (
    <div>
      <Header />
       {/* Render Sidebar for settings pages */}
       <div className={isMobile ? 'w-100' : 'd-flex flex-row'} >
            {isSettingsPage && sidebarVisible &&
             <Sidebar title='Settings' menu={<SettingsMenu onSelect={() => isMobile && setShowSidebar(false)} />} />}
            <main className="container mt-2">{children}</main> 
       </div>
    </div>
  );
};

export default Layout;
